import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'FlowCore',
  brandName: 'FlowCore',
  description: 'Sistema de agendamento para estúdios de ioga e pilates',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Aula de yoga em estúdio',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Instrutor guiando praticantes',
  },
  testimonials: [
    {
      name: 'Sofia Monteiro',
      role: 'Instrutora de Yoga',
      text: 'O FlowCore tornou a gestão das minhas aulas e workshops muito mais fluida e organizada.',
      image: testimonial1,
    },
    {
      name: 'Rui Mendes',
      role: 'Praticante de Pilates',
      text: 'Marcar as minhas aulas através da plataforma é muito simples e ajuda-me a manter a consistência.',
      image: testimonial2,
    },
    {
      name: 'Estúdio Corpo & Mente',
      role: 'Gerente',
      text: 'Excelente ferramenta para gerir o mapa de aulas, os instrutores e os alunos. Tudo num só lugar.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'instrutor',
    professionals: 'instrutores',
    business: 'estúdio',
    businesses: 'estúdios',
    service: 'aula',
    services: 'aulas',
    client: 'praticante',
    clients: 'praticantes',
    appointment: 'aula',
    appointments: 'aulas',
  },
  homepage: {
    hero: {
      badge: 'Bem-Estar & Equilíbrio',
      title: 'Equilibre seu estúdio com FlowCore',
      description: 'Simplifique a gestão das suas aulas e foque no que realmente importa: o bem-estar dos seus praticantes.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Ver Demonstração',
      features: ['Sem complicações', 'Harmonia digital'],
    },
    statistics: [
      { value: '150+', label: 'Estúdios' },
      { value: '20k+', label: 'Aulas Agendadas' },
      { value: '98%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Gestão de Turmas Lotadas',
        description: 'Controlar limites de vagas e listas de espera em aulas populares gera stress desnecessário.',
        icon: 'Users',
        quote: {
          text: 'Antes tinha aulas sobrelotadas e praticantes frustrados. Agora tudo flui naturalmente',
          author: 'Ana Lúcia',
          business: 'Estúdio Namasté',
        },
      },
      {
        title: 'Cancelamentos de Última Hora',
        description: 'Praticantes que cancelam em cima da hora deixam vagas que outros poderiam aproveitar.',
        icon: 'Clock',
        stats: [
          { label: 'Taxa de cancelamento:', value: '25%' },
          { label: 'Vagas perdidas por semana:', value: '40+' },
        ],
      },
      {
        title: 'Pagamentos Descoordenados',
        description: 'Gerir planos mensais, aulas avulsas e workshops sem sistema adequado cria confusão.',
        icon: 'CreditCard',
        quote: {
          text: 'O FlowCore organizou completamente nossa gestão financeira. Paz total!',
          author: 'Ricardo Santos',
          business: 'Flow Pilates Studio',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'FlowCore: Tecnologia em harmonia',
      description: 'Uma plataforma intuitiva que respeita a filosofia do yoga e pilates enquanto otimiza seu negócio.',
      features: [
        {
          title: 'Reservas com Limite de Vagas',
          description: 'Controlo automático de capacidade com lista de espera inteligente.',
        },
        {
          title: 'Calendário de Aulas Flexível',
          description: 'Organize aulas regulares, workshops e retrétios facilmente.',
        },
        {
          title: 'Comunidade Integrada',
          description: 'Conecte praticantes e instrutores numa experiência harmoniosa.',
        },
      ],
    },
    testimonials: {
      title: 'Depoimentos da nossa comunidade',
      description: 'Instrutores e estúdios que encontraram equilíbrio com FlowCore.',
    },
    finalCta: {
      title: 'Pronto para encontrar seu equilíbrio digital?',
      description: 'Junte-se aos estúdios que já alcançaram harmonia entre tecnologia e bem-estar.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Explorar Funcionalidades',
    },
    contact: {
      title: 'Conecte-se Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de instrutor',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
